import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Globals } from '../globals';
import { ProductoService } from '../servicios/producto.service';
import { MatListModule } from '@angular/material/list';
import { ExcelService } from '../services/excel.service';
interface ProductData {
  stockid: string;
  description: string;
  precio_final_con_impuesto_format: string;
}
@Component({
  selector: 'app-modal-descargar-productos-excel',
  templateUrl: './modal-descargar-productos-excel.component.html',
  styleUrls: ['./modal-descargar-productos-excel.component.scss']
})
export class ModalDescargarProductosExcelComponent implements OnInit {
  categoriasSeleccionadas = {}; // Cambiado de un array a un objeto
  constructor(
    public dialogRef: MatDialogRef<ModalDescargarProductosExcelComponent>,
    public globals: Globals,
    private productoService: ProductoService,
    private router: Router,
    private excelService: ExcelService
  ) { }

  categorias = {
    cargando: true,
    registros: new Array()
  }
  cargando: boolean = false;
  ngOnInit(): void {
    this.categoriasListado();
  }



  toggleCategoriaSeleccionada(categoriaId: string) {
    
    if (this.categoriasSeleccionadas[categoriaId]) {
        // Esto verificará la categoría en caso de que no esté seleccionada
        this.categoriasSeleccionadas[categoriaId] = true;
    } else {
        // Esto desmarcará la categoría en caso de que esté seleccionada
        this.categoriasSeleccionadas[categoriaId] = false;
    }
    console.log('this.categoriasSeleccionadas',this.categoriasSeleccionadas)
}
descargar(){
    this.cargando = true;
    const categoriasSeleccionadas = Object.entries(this.categoriasSeleccionadas)
      .filter(([id, seleccionado]) => seleccionado)
      .map(([id, seleccionado]) => id);
    this.productoService.productoListado({
     
      registros_por_pagina:'all',
      // pagina_actual  : pageNumber,
      categoria: categoriasSeleccionadas,
      marca: this.globals.configuracion.front.listado.marca,
      modelo: this.globals.configuracion.front.listado.modelo,
      ordenar: this.globals.configuracion.front.listado.ordenar_new,
      ordenar_modo: this.globals.configuracion.front.listado.ordenar_modo,
      typeabbrev: this.globals.configuracion.front.typeabbrev,
      modelos: this.globals.configuracion.front.listado.modelos,
      tags: this.globals.configuracion.front.listado.tags,
      tag: this.globals.configuracion.front.listado.tag,
    }).subscribe( async response => {
        await this.excelService.generateExcel(response.registros);
        this.cargando = false;
    });
}
  categoriasListado(){
    this.categorias.cargando = true;

    this.productoService.categoriaListado().subscribe(
        resultado =>{
          if( !resultado.error ){
            Array.prototype.push.apply( this.categorias.registros, resultado.registros );
            
            resultado.registros.map( registro => {
              
              this.categoriasSeleccionadas[registro.categoryid] = false;
            })
            console.log(this.categoriasSeleccionadas)
            this.categorias.cargando = false;
          }else{
            console.log("Error",resultado.mensaje);
          }

        },
        error =>{
          console.log("Error",error);
          //this.feedProductos.cargando = false;
        }
      )
  }
  closeModal(): void {
    this.dialogRef.close();
  }

}
